<div class="vertical-container-simple column-gap-1">
  <ng-container *ngFor="let chart of chosenPPCharts">
    <div *ngIf="chart.chosen" class="pd-top-1">
      <div class="space-between-horizontal">
        <div class="start-row-container select-container" *ngVar="fp.realizedCompaniesAmount && fp.activeCompaniesAmount as showActiveSold">
          <div class="{{showActiveSold ? 'xAxis-whitespace-0p25' : 'xAxis-whitespace-1p625'}}"></div>
          <app-three-dots-menu *ngIf="showActiveSold" (click)="chart.showModal = true"></app-three-dots-menu>
          <app-popup-modal *ngIf="chart.showModal" (closeModal)="chart.showModal = false">
            <div class="select-body" id="charts-select-body">
              <app-checkbox
                [isContentLeft]="true"
                [checked]="true"
                [disabled]="true">
                Total
              </app-checkbox>
              <app-checkbox
                [isContentLeft]="true"
                [checked]="this.chosenPPCharts[1].chosen"
                (change)="this.chosenPPCharts[1].chosen = !this.chosenPPCharts[1].chosen">
                Active
              </app-checkbox>
              <app-checkbox
                [isContentLeft]="true"
                [checked]="this.chosenPPCharts[2].chosen"
                (change)="this.chosenPPCharts[2].chosen = !this.chosenPPCharts[2].chosen">
                Realized
              </app-checkbox>
            </div>
          </app-popup-modal>
          <span class="font-2 bold600">
            {{chart.name.charAt(0).toUpperCase() + chart.name.slice(1) + ' portfolio performance'}}
          </span>
        </div>
        <app-checkbox-selector data-qa="value-creation-chart-total-portfolio-period-selector"
          class="width-11"
          [items]="chartPeriods"
          (itemEmitter)="rerender($event)">
        </app-checkbox-selector>
      </div>
      <app-portfolio-performance-chart
        [parent]="'fp-fund'"
        [updateTrigger]="updateSelectedPeriodsForCharts"
        [chartPeriods]='chartPeriods'
        [fundPerformances]="fundPerformances"
        [showTitle]="false"
        [selector]="chart.name"
        [showEmptyState]="!fp.totalFmv">
      </app-portfolio-performance-chart>
    </div>
  </ng-container>
  <div *ngIf="isAdmin || fpsHaveChartData">
    <!-- Net Performance Chart -->
    <div class="space-between-horizontal-centered">
      <span class="font-2 bold600">Net fund performance</span>
      <app-checkbox-selector data-qa="value-creation-chart-net-fund-performance-period-selector"
        class="width-11"
        [items]="chartPeriods"
        (itemEmitter)="rerender($event)">
      </app-checkbox-selector>
    </div>
    <app-net-fund-performance-chart
      *ngIf="fundPerformances"
      [updateTrigger]="updateSelectedPeriodsForCharts"
      [chartPeriods]='chartPeriods'
      [fundPerformances]="fundPerformances"
      [showTitle]="false"
      [parent]="'fund-performance'"
      [showEmptyState]="!fpsHaveChartData">
    </app-net-fund-performance-chart>
  </div>
</div>
